import CardFrontEdit from '~/components/CardMaker/components/CardFrontEdit';
import CardText from '~/components/CardMaker/components/CardFrontEdit/CardText';
import CardArt from '~/components/CardMaker/components/CardFrontEdit/CardArt';
import { useDispatch } from 'react-redux';
import cloneDeep from 'lodash/cloneDeep';
import React from 'react';
import { updateCategories } from '../../adventureCardSlice';

export function renderAdventureCardFrontEdit(name, categoryId, categories) {
    return (tempUrl, setTempUrl, convertedContent, nameColor, frontSides) => {
        const dispatch = useDispatch();

        //display picture dynamically upon selecting category.
        React.useEffect(() => {
            const selected = categories.find((cat) => cat.id == categoryId);

            setTempUrl((prev) => ({
                ...prev,
                cardFrame: selected.template.cardFrame,
            }));
        }, [categoryId]);

        // when uploading new cardFrame, update their values in redux so that they can display as preview in next selection.
        React.useEffect(() => {
            let selected = categories.find((item) => item.id == categoryId);

            if (selected.template.cardFrame === tempUrl.cardFrame) return;

            selected = cloneDeep(selected);
            selected.template.cardFrame = tempUrl.cardFrame;

            dispatch(updateCategories(selected));
        }, [tempUrl.cardFrame]);

        return (
            <CardFrontEdit
                cardFrame={tempUrl.cardFrame}
                id={frontSides.find((item) => item.includes('.')) || 'cardFrame'}
                cardArtElement={<CardArt cardArt={tempUrl.cardArt} />}
                cardTextElement={
                    <CardText
                        title={name}
                        description={convertedContent}
                        nameColor={nameColor}
                    />
                }
            />
        );
    };
}
